import React from 'react';
import './BlogPost.css';

import logo from '../../images/2022-band-shooting.jpg';

class BlogPost4 extends React.Component {
  render() {
    return (
    <div className="blogpost-outer">
      <div className="blogpost-title">
        <h3 className="blogpost-h3" >Fotoshooting!     -     19. Januar 2022</h3>
      </div>
      <div className="blogpost-content">
        <div className="blogpost-image">
          <img className="image-fit" alt="" src={logo}/>
        </div>
        <div className="blogpost-text">
          Um auch mal wieder unsere Social-Media-Kanäle bespielen zu können, haben wir uns endlich zu einem semi-professionellen Fotoshooting durchringen können. Für den professionellen Teil danken wir auf jeden Fall Yannic Gesenhues, der das ganze Chaos festhalten durfte!
        </div>

      </div>
    </div>
    )
  }
}

export default BlogPost4;


// WEBPACK FOOTER //
// ./src/components/blog/BlogPost7.js